import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ContextGuardService } from './context-guard.service';

export const contextGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _state,
  contextGuardService: ContextGuardService = inject(ContextGuardService)
): Observable<true | UrlTree> => {
  return contextGuardService.canActivate(route);
}
